<template>
  <div>
    <presentacion-modulo-app :datos="data"></presentacion-modulo-app>
    <audio-player ref="audioPlayer" :autoplay="true" :audios="[
    'Modulo 3/AUDIO 01'
    ]"></audio-player> 
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {
        "titulo": "",
        "nombreModulo": "Módulo 3" ,
        "texto": "Métodos de estimación"
      }
    }
  },
  created() {
    this.$store.commit('nextShow', true)
  }
}
</script>
